<template>
  <div class="tab-panel">
    <!-- pc端 -->
    <div class="new-content" v-if="news.length">
      <div class="left">
        <ul>
          <li
            v-for="(item, index) in news.slice(0, 3)"
            :key="index"
            @click="gotoDetail(item.id)"
          >
            <img :src="item.img" alt="" />
            <p class="date">
              {{ moment(item.createdate).format("yyyy-MM-DD") }}
            </p>
            <h3>{{ item.title }}</h3>
            <p class="desc" v-html="delHtmlTag(item.content)"></p>
          </li>
        </ul>
      </div>
      <div class="center">
        <div @click="gotoDetail(news[3].id)" class="center-inner">
          <img :src="news[3].img" alt="" />
          <p class="date">{{ moment(news[3].createdate).format("yyyy-MM-DD") }}</p>
          <h3>{{ news[3].title }}</h3>
          <p class="desc" v-html = "news[3].content"></p>
        </div>
      </div>
      <div class="right">
        <ul>
          <li v-for="(item, index) in news.slice(4, 8)" :key="index" @click="gotoDetail(item.id)">
            <h3>{{ item.title }}</h3>
            <div class="con">
              <img :src="item.img" alt="" />
              <div class="con-right">
                <p class="desc"  v-html = "delHtmlTag(item.content)" ></p>
                <p class="date">{{ moment(item.createdate).format("yyyy-MM-DD") }}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 移动端 -->
    <div class="new-content-mobile">
      <ul>
        <li v-for="(item, index) in news" :key="index" @click="gotoDetail(item.id)">
          <div class="left">
            <h3>{{ item.title }}</h3>
            <p>{{ delHtmlTag(item.content) }}</p>
          </div>
          <div class="right">
            <img :src="item.img" alt="" />
            <p class="time">{{ moment(item.createdate).format("yyyy-MM-DD") }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getNewsList ,getNewsLayout} from "@/api/news.js";
import { delHtmlTag } from "@/utils/index.js";
export default {
  data() {
    return {
      news: [],
    };
  },
  methods: {
    moment,
    delHtmlTag,
    getList(){
      getNewsLayout({
        categorys: '新闻资讯'
      }).then(res=>{
        console.log('getList',res.data,this.news);
        this.news = [
        res.data.left1,
        res.data.left2,
        res.data.left3,
        res.data.mid,
        res.data.right1, 
        res.data.right2,
        res.data.right3,
        res.data.right4];
         console.log('getList2',res.data,this.news);
        this.total = res.data.total;
      })
    },
    gotoDetail(id) {
      this.$router.push(`/news/newsDetail?id=${id}`);
    },
  },
  mounted(){ 
      this.getList();
  },
};
</script>

<style lang="scss" scoped>
.tab-panel {
  width: 100%;
}
@media screen and (min-width: 961px) {
  .new-content-mobile {
    display: none;
  }
  .new-content {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    padding: 30px 0 0;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(216, 216, 216, 0.43);
    max-height: 925px;
    box-sizing: content-box;
    .left {
      width: 25%;
      box-sizing: border-box;
      padding-right: 30px;
      li {
        border-bottom: 1px solid rgba(216, 216, 216, 0.43);
        margin-bottom: 30px;
        padding-bottom: 25px;
        height: 33.3%;
        box-sizing: border-box;
        p,
        h3 {
          line-height: 25px;
        }
        p.date {
          height: 14px;
          font-size: 14px;

          font-weight: 400;
          color: #da5351;
          line-height: 14px;
          margin: 12px 0px 17px 0px;
        }
        h3 {
          color: #222222;
          font-weight: 400;
          font-size: 18px;
          height: 18px;
          line-height: 18px;
          display: -webkit-box;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          overflow: hidden;
          -webkit-box-orient: vertical;
        }
        p.desc {
          color: #666666;
          font-weight: 400;
          display: -webkit-box;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          overflow: hidden;
          -webkit-box-orient: vertical;
          height: 48px;
          font-size: 16px;
          margin-top: 9px;
          line-height: 24px;
          word-break: break-all;
          white-space: normal;
        }
      }
      img {
        width: 259px;
        height: 140px;
        border-radius: 6px;
      }
      li:last-child {
        border: none;
      }
    }
    .center {
      width: 50%;
      border-left: 1px solid rgba(216, 216, 216, 0.43);
      border-right: 1px solid rgba(216, 216, 216, 0.43);
      padding-left: 30px;
      padding-right: 30px;
      box-sizing: border-box;
      .center-inner{
        overflow: hidden;
        height: calc(100% - 20px);
      }
      p,
      h3 {
        line-height: 30px;
      }
      img {
        width: 537px;
        height: 290px;
        border-radius: 6px;
      }
      p.date {
        height: 14px;
        font-size: 14px;
        font-weight: 400;
        color: #da5351;
        line-height: 14px;
        margin: 12px 0px 6px 0px;
      }
      h3 {
        color: #222222;
        font-size: 28px;
        font-weight: 400;
        line-height: 1.5;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        overflow: hidden;
        -webkit-box-orient: vertical;
      }
      p.desc {
        font-size: 16px;
        color: #666666;
        text-overflow: ellipsis;
        font-weight: 400;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 16;
        word-break: break-all;
        ::v-deep{
          img{
            max-width: 100%;
            object-fit: unset;
            height: auto;
          }
        }
      }
    }
    .right {
      width: 25%;
      padding-left: 30px;
      ul {
        height: 100%;
      }
      li {
        height: 26%;
        box-sizing: border-box;
        &:nth-child(1) {
          height: 22%;
        }
        h3 {
          white-space: nowrap;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          overflow: hidden;
          -webkit-box-orient: vertical;
          font-size: 18px;
          font-weight: 400;
          color: #222222;
          border-bottom: 1px solid rgba(216, 216, 216, 0.43);
          padding-bottom: 30px;
          box-sizing: border-box;
        }
        img {
          width: 185px;
          height: 103px;
          border-radius: 6px;
          margin-right: 7px;
        }
        .con {
          display: flex;
          flex-direction: row;
          margin-top: 19px;
          margin-bottom: 30px;
          border-bottom: 1px solid rgba(216, 216, 216, 0.43);
          padding-bottom: 30px;
          box-sizing: border-box;
          &-right {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }
          p.desc {
            color: #666666;
            font-size: 14px;
            font-weight: 400;
            width: 116px;
            color: #666666;
            line-height: 22px;
            display: -webkit-box;
            text-overflow: ellipsis;
            -webkit-line-clamp: 3;
            overflow: hidden;
            -webkit-box-orient: vertical;
          }
          p.date {
            font-size: 14px;
            font-weight: 400;
            color: #b2b2b2;
          }
        }
      }
      li:last-child .con {
        border: none;
      }
    }
  }
}
@media screen and (max-width: 960px) {
  .new-content {
    display: none;
  }
  .new-content-mobile li {
    height: 1.12rem;
    width: 100%;
    color: #666666;
    padding: 0.1rem 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #f1f1f1;
    display: flex;
    justify-content: space-between;
    .right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      img {
        width: 1.2rem;
        height: 0.68rem;
        border-radius: 0.04rem;
      }
      .time {
        font-size: 0.12rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.14rem;
        text-align: right;
        margin-top: 0.1rem;
      }
    }

    .left {
      flex: 1;
      margin-right: 0.32rem;
      h3 {
        font-size: 0.14rem;
        font-weight: 500;
        color: #454545;
        line-height: 0.22rem;
        font-size: 0.14rem;
       
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        overflow: hidden;
        -webkit-box-orient: vertical;
        word-break: break-all;
        white-space: normal;

      }
      p {
        font-size: 0.12rem;
        font-weight: 400;
        color: #999999;
        line-height: 0.2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        word-break: break-all;
        white-space: normal;
      }
    }
  }
}
</style>